import React, { FC } from "react";
import { Box, Button, Icon } from "zmp-ui";

export const QuantityPicker = ({ value, width = "auto", onChange }) => {
  return (
    <Box
      flex
      className="border border-[#e9ebed] rounded-full p-[6px] rounded-md"
      style={{ width: width, border: "none" }}
      alignItems="center"
    >
      <Button
        disabled={value < 2}
        onClick={() => value > 1 && onChange(value - 1)}
        variant="secondary"
        type="neutral"
        className="plus-cart-btn"
        icon={
          <div className="py-3 px-[0.35rem]">
            <div className="w-[12px] h-[2px] bg-black" />
          </div>
        }
        style={{ opacity: value < 2 ? 0.3 : 1 }}
      />
      <Box
        flex
        justifyContent="center"
        alignItems="center"
        className="flex-1 box-input"
      >
        <input
          type={"number"}
          value={value}
          style={{
            width: "60px",
            margin: "0 4px",
            height: "38px",
            textAlign: "center",
            fontWeight: 600,
            fontSize: 14,
          }}
          onChange={(e) => {
            if (+e.target.value === 0) onChange("");
            else if (+e.target.value > 0 && +e.target.value < 10000)
              onChange(Math.round(+e.target.value));
          }}
        />
      </Box>
      <Button
        onClick={() => onChange(value + 1)}
        variant="secondary"
        type="neutral"
        className="plus-cart-btn"
        icon={<Icon icon="zi-plus" />}
      />
    </Box>
  );
};

export const QuantityCartPicker = ({ value, width = "auto", page = "cart", onChange }) => {
  return (
    <Box
      flex
      className="border border-[#e9ebed] rounded-full rounded-md input-quantity"
      style={{
        width: width,
        borderRadius: "60px",
        padding: "1px 4px",
        border: "0.5px solid var(--gray-line, #DBDDE4)",
      }}
      alignItems="center"
    >
      <Button
        onClick={() => {
           if(+value > 0) onChange(+value - 1)
        }}
        variant="secondary"
        type="neutral"
        className="plus-cart-btn__page"
        icon={
          value < 0 ? (
            <div
              className="px-[0.35rem] w-[12px]"
              style={{ paddingTop: "6px" }}
            >
              <svg
                width="10"
                height="12"
                viewBox="0 0 10 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.69636 12C1.41274 12 1.17143 11.892 0.97243 11.6759C0.773426 11.4599 0.673924 11.1979 0.673924 10.8899V1.669H0V0.558924H2.96522V0H7.03121V0.558924H10V1.669H9.32608V10.8899C9.32608 11.1897 9.22471 11.4497 9.02196 11.6698C8.81922 11.8899 8.57978 12 8.30364 12H1.69636ZM8.30364 1.669H1.69636V10.8899H8.30364V1.669ZM3.26365 9.51989H4.22172V3.01887H3.26365V9.51989ZM5.77828 9.51989H6.73992V3.01887H5.77828V9.51989Z"
                  fill="#0F172A"
                />
              </svg>
            </div>
          ) : (
            <div className="py-3 px-[0.35rem]" style={{ paddingLeft: "7px" }}>
              <div className="w-[10px] h-[1px] bg-black" />
            </div>
          )
        }
      />
      <Box flex justifyContent="center" alignItems="center" className="flex-1">
        <input
          type={"number"}
          value={value}
          style={{
            maxWidth: "50px",
            height: "28px",
            textAlign: "center",
            fontWeight: 600,
            fontSize: 14,
            color: "#3264FF",
            border: "none",
            margin: 0,
            outline: "none",
          }}
          onChange={(e) => onChange(e.target.value)}
          onBlur={(e) => {
            if (!!!e.target.value) onChange(page === "cart" ? 1 : "0");
          }}
        />
      </Box>
      <Button
        onClick={() => onChange(+value + 1)}
        variant="secondary"
        type="neutral"
        className="plus-cart-btn__page"
        icon={<Icon icon="zi-plus" />}
      />
    </Box>
  );
};
